import { useMutation } from '@tanstack/react-query';

import type {
  SeriesOverlap,
  UpdateSeriesPayload,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useValidateUpdateSeries(hotelId?: number, calendarId?: number) {
  return useMutation({
    mutationFn: ({
      seriesId,
      payload,
    }: {
      seriesId: number;
      payload: UpdateSeriesPayload;
    }) =>
      hotelId !== undefined && calendarId !== undefined
        ? (apiMutation(
            'PUT',
            {
              path: ENDPOINTS.validateUpdateSeries,
              params: {
                hotelId: hotelId.toString(),
                calendarId: calendarId.toString(),
                seriesId: seriesId.toString(),
              },
            },
            payload
          ) as Promise<SeriesOverlap>)
        : Promise.reject(null),
  });
}
